// Comparator mode prices the whole catalogue before the customer gave their real
// consumption, so it falls back to representative yearly values.
const FALLBACK_CAR_ELEC = 1200
const FALLBACK_CAR_GAS = 150

export const comparatorConsumption = consumptionData => {
  const { consumptionBase, consumptionBiorariaF1, consumptionBiorariaF2, consumptionBiorariaF3, carGas } =
    consumptionData ?? {}

  const bioraria = (consumptionBiorariaF1 || 0) + (consumptionBiorariaF2 || 0) + (consumptionBiorariaF3 || 0)

  return {
    carElec: consumptionBase || bioraria || FALLBACK_CAR_ELEC,
    carGas: carGas || FALLBACK_CAR_GAS,
    gasUnit: 'Smc',
  }
}
